<template>
  <div>
    <v-menu content-class="notification-list-menu" :value="open" max-width="600" offset-y close-delay="300">
      <template v-slot:activator="{ on }">
        <div>
          <v-badge
            color="green"
            v-if="unreadNotifications > 0"
            :content="unreadNotifications"
            offset-x="16"
            offset-y="16">
            <v-btn icon v-on="on" @click="read">
              <v-icon v-if="hasRunningTasks">mdi-loading mdi-spin mdi-anim-1s</v-icon>
              <v-icon v-else>mdi-check</v-icon>
            </v-btn>
          </v-badge>
          <v-btn icon v-else v-on="on" @click="read">
            <v-icon v-if="hasRunningTasks">mdi-loading mdi-spin mdi-anim-1s</v-icon>
            <v-icon v-else>mdi-check</v-icon>
          </v-btn>
        </div>
      </template>

      <v-card>
        <v-list v-if="notifications.length > 0">
          <template v-for="(notification, i) in notifications">
            <v-list-item :key="i" @click="click(notification)">
              <v-list-item-avatar>
                <v-icon :color="notification.color">{{ notification.icon }}</v-icon>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-subtitle>{{ $moment(notification.date).fromNow() }}</v-list-item-subtitle>
                <v-list-item-title v-text="notification.message"></v-list-item-title>
                <v-list-item-subtitle v-if="notification.description" v-text="notification.description">
                </v-list-item-subtitle>
                <v-list-item-subtitle v-if="notification.progress">
                  <v-progress-linear
                    class="mt-2"
                    :color="notification.color"
                    :value="notification.progress">
                  </v-progress-linear>
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-icon :disabled="notifications.persistent" @click="remove(i)">mdi-close</v-icon>
              </v-list-item-action>
            </v-list-item>
          </template>
        </v-list>

        <v-card-text v-else class="text-center pt-8">
          <v-icon class="mb-2">mdi-check</v-icon>
          <br/>
          {{ $t('notifications') }}<br/>
          {{ $t('updated') }}
        </v-card-text>

        <v-card-actions>
          <v-btn block text small @click="purge">
            {{ $t('empty-notifications') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: 'AppBarNotifications',
  data () {
    return {
      objects: this.$carrier.collection({
        missing: []
      }),
      open: undefined
    }
  },
  watch: {
    open (open) {
      if (open) this.read()
    }
  },
  computed: {
    unreadNotifications () {
      return this.notifications.filter(notification => notification.read === false).length
    },
    hasRunningTasks () {
      return this.notifications.filter(n => {
        return n.meta && n.meta.includes('task')
      }).length > 0
    },
    notifications () {
      return this.objects.get(this.$models.CarrierObjects.userNotifications())
    }
  },
  methods: {
    async purge () {
      await this.$api.delete('notifications', null, { silent: true })
    },
    async read () {
      await this.$api.post('notifications/read', null, { silent: true })
    },
    async remove (index) {
      await this.$api.delete('notifications/' + index, null, { silent: true })
    },
    click (notification) {
      if (notification['click-event']) {
        this.$bus.emit(notification['click-event'])
      }
    },
    onEvent () {
      this.open = true
    }
  },
  mounted () {
    this.$bus.on('notifications/open', this.onEvent)

    if (this.$account.isVerified) {
      this.objects.sync([this.$models.CarrierObjects.userNotifications()])
    } else {
      this.objects.purge()
    }
  },
  destroyed () {
    this.$bus.off('notifications/open', this.onEvent)
  }
}
</script>

<style>
.notification-list-menu .v-list-item__title {
  font-size: 0.875rem !important;
}

.notification-list-menu .v-list-item__title, .notification-list-menu .v-list-item__subtitle {
  white-space: normal !important;
}

.notification-list-menu {
  left: initial !important;
  right: 10px !important;
}
</style>

<i18n>
{
	"en": {
		"empty-notifications": "Clear notifications",
		"notifications": "No notification to display,",
		"updated": "you are up to date :)"
	},
	"es": {
		"empty-notifications": "Vaciar las notificaciones ",
		"notifications": "Ninguna notificación para mostrar,",
		"updated": "esta actualizado :)"
	},
	"fr": {
		"empty-notifications": "Vider les notifications",
		"notifications": "Aucune notification à afficher,",
		"updated": "vous êtes à jour :)"
	},
	"it": {
		"empty-notifications": "Svuota le notifiche",
		"notifications": "Nessuna notifica da visualizzare,",
		"updated": "sei aggiornato :)"
	},
	"pt": {
		"empty-notifications": "Limpar notificações",
		"notifications": "Nenhuma notificação a exibir,",
		"updated": "está atualizado :)"
	},
	"pl": {
		"empty-notifications": "Wyczyść powiadomienia",
		"notifications": "Brak powiadomień do wyświetlenia,",
		"updated": "jesteś na bieżąco :)"
	}
}
</i18n>
